export default __webpack_public_path__ + "i18n/pl.529715ddabab24f187df3356b33621cb.json";